import React from 'react';
import { Link } from 'react-router';

import './DoctorsList.scss';

import doctorsImgs from '../../../assets/img/llc/doctors/';

class DoctorsList extends React.PureComponent {
  renderDoctors = () => {
    const doctors = this.props.langs.doctors;

    return doctors.map((doctor) => {
      return (
        <div
          className="col-6 doctorsList_item_col"
          key={doctor.id}
        >
          <div className="doctorsList_item">
            <div className="doctorsList_item_img"><img src={doctorsImgs[doctor.photoId]}/></div>
            <div className="doctorsList_item_name">{doctor.name}</div>
            <div className="doctorsList_item_title">{doctor.text}</div>
            {/* <div className="doctorsList_item_desc">
              V oboru otorinolaryngologie a chirurgie hlavy a krku je
              renomovaným odborníkem s dlouholetou chirurgickou praxí.
            </div> */}
            <Link to={"lekar/" + doctor.id} className="doctorsList_item_btn">Celý profil</Link>
          </div>
        </div>
      )
    });
  };

  render() {


    return (
      <section className="doctorsList">
        <div className="container">
          <div className="row doctorsList_row">
            {this.renderDoctors()}
          </div>
        </div>
      </section>
    );
  }
}

export default DoctorsList;



// WEBPACK FOOTER //
// ./src/components/Doctors/DoctorsList/DoctorsList.js